module.exports = __webpack_public_path__ + "static/BT-desktop-7-1dbed58010316c925c881ab14b0d590d.jpg";